import StarField from "@/components/StarField";
import Constellation from "@/components/Constellation";

const NEBULA =
  "https://images.unsplash.com/photo-1789394185034-a207ced7802a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwzfHxjb2xvcmZ1bCUyMHNwYWNlJTIwbmVidWxhJTIwZGVlcCUyMGNvc21vc3xlbnwwfHx8fDE3OTEyMzQxNjl8MA&ixlib=rb-4.1.0&q=85";

// Zodiac constellations that slowly phase in and out across the sky.
const PHASING = [
  { sign: "Leo", top: "8%", left: "6%", size: 150, dur: "17s", delay: "0s", peak: 0.5 },
  { sign: "Scorpio", top: "22%", left: "58%", size: 170, dur: "21s", delay: "4s", peak: 0.42 },
  { sign: "Gemini", top: "46%", left: "4%", size: 140, dur: "19s", delay: "9s", peak: 0.45 },
  { sign: "Sagittarius", top: "60%", left: "60%", size: 160, dur: "23s", delay: "2s", peak: 0.4 },
  { sign: "Pisces", top: "78%", left: "10%", size: 150, dur: "18s", delay: "12s", peak: 0.46 },
  { sign: "Taurus", top: "84%", left: "56%", size: 150, dur: "20s", delay: "6s", peak: 0.42 },
];

export default function CelestialBackground() {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" style={{ zIndex: 0 }} aria-hidden>
      {/* Deep void base */}
      <div className="absolute inset-0 bg-[#04060B]" />

      {/* Nebula layer, softened and tinted toward indigo/gold */}
      <div className="absolute inset-0 overflow-hidden">
        <img
          src={NEBULA}
          alt=""
          className="absolute inset-0 w-full h-full object-cover nebula-drift"
          style={{ opacity: 0.28, mixBlendMode: "screen" }}
        />
      </div>

      {/* Indigo veil + vignette so the nebula stays subtle and on-brand */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(130% 90% at 50% 15%, rgba(17,24,43,0.25) 0%, rgba(4,6,11,0.72) 55%, rgba(4,6,11,0.95) 100%)",
        }}
      />

      {/* Phasing zodiac constellations */}
      {PHASING.map((c, i) => (
        <div
          key={i}
          className="absolute phase-const"
          style={{ top: c.top, left: c.left, "--phase-dur": c.dur, "--phase-peak": c.peak, animationDelay: c.delay }}
        >
          <Constellation sign={c.sign} size={c.size} />
        </div>
      ))}

      {/* Twinkling star field on top */}
      <StarField />
    </div>
  );
}
